import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerLicense } from '@syncfusion/ej2-base';
import { initializeSyncfusionAppearance } from './theme/syncfusionTheme';
import { initializeAgGrid } from './grids/agGridSetup';
import { getRuntimeConfig, loadRuntimeConfig } from './config/runtimeConfig';

import App from './App';
import './index.css';

async function bootstrap() {
  await loadRuntimeConfig();
  const { syncfusionLicenseKey } = getRuntimeConfig();

  // Register Syncfusion license
  registerLicense(syncfusionLicenseKey || '');

  // Register AG Grid modules + Enterprise license (holdings and future report grids).
  initializeAgGrid();

  // Applies the persisted (or default) Syncfusion theme + density before first paint.
  // Note: Charts don't have a separate CSS file - styles are in ej2-base.
  initializeSyncfusionAppearance();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

void bootstrap();
